import { Alert, AlertSource } from '@app/client/alerts/state/alerts-state.models';
import { AlertMenuType } from '@app/client/settings/user/modules/alert-settings/alert-settings.model';
import { ApiGetAction } from '@app/core/store/models/api-action.models';

export class GetAlertsInit {
  static readonly type = '[Alerts] Get Alerts Init';

  constructor(readonly source: AlertSource) {}
}

export class GetUnreadAlertsCount {
  static readonly type = '[Alerts] Get Unread Alerts Count';
}

export class GetDrawerAlerts extends ApiGetAction<Alert> {
  static readonly type = '[Alerts] Get Drawer Alerts';
}

export class GetPageAlerts extends ApiGetAction<Alert> {
  static readonly type = '[Alerts] Get Page Alerts';
}

export class MuteAlert {
  static readonly type = '[Alerts] Mute Alert';

  constructor(
    readonly definitionId: string,
    readonly muteType: AlertMenuType,
  ) {}
}

export class SetAlertRead {
  static readonly type = '[Alerts] Set Alert Read';

  constructor(
    readonly alertId: number,
    readonly read: boolean,
  ) {}
}

export class SetAlertResolved {
  static readonly type = '[Alerts] Set Alert Resolved';

  constructor(
    readonly alertId: number,
    readonly cleared: boolean,
  ) {}
}

export class GetAlertCategories {
  static readonly type = '[Alerts] Get Alert Categories';
}
